import { Msg, MsgService } from "../../msg";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  Inject,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormArray,
  FormGroup,
  FormBuilder,
  FormControl
} from "@angular/forms";
import {AlertService, AuthenticationService} from '@app/_services';
import * as moment from "moment";
import { PrimeNGConfig } from "primeng/api";
import { MsgRecipient } from "@app/_components/msg-recipient/msg-recipient";
import {User} from '@app/_models';
import {Subscription} from 'rxjs';
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';

@Component({
    selector: "app-send-full-mail",
    templateUrl: "./send-full-mail.component.html",
    styleUrls: ["./send-full-mail.component.css"],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class SendFullMailComponent implements OnInit {
  private toEmails: string;
  private ccEmails: string;
  private bccEmails: string;
  private proforma: any;
  currentUser: User;
  currentUserSubscription: Subscription;
  private toTagsSelected: any;
  private ccTagsSelected: any;
  private bccTagsSelected: any;
  showSendToNewUser: boolean = false; // Update true in realtor portal
  showTemplate: boolean = true; //Update to false in realtor portal
  showTags: boolean = true; //Update to false in realtor portal
  constructor(
    private primengConfig: PrimeNGConfig,
    private msgService: MsgService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private authenticationService: AuthenticationService,
    private msgTemplateService: MsgTemplateService,
    private _formBuilder: FormBuilder,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title,
      this.msg = data.msg,
      this.toEmails = data.toEmails,
      this.ccEmails = data.ccEmails,
      this.bccEmails = data.bccEmails,
      this.proforma = data.proforma;
      this.msgTemplateId = data.msgTemplateId;
      this.statuses = msgService.statuses;
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  @Input() msg: Msg;
  @Input() toMails: any;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();


  // data
  msgId: number;
  selectedMsgRecipients: any[] = [];

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    msgId: [],
    sentDate: [],
    receivedDate: [],
    senderName: [{ type: 'required', message: 'Required' }],
    senderEmail: [{ type: 'required', message: 'Required' }],
    senderMobileNum: [],
    senderCountryCode: [],
    toEmail: [{ type: 'required', message: 'Required' }],
    ccEmail: [],
    bccEmail: [],
    subject: [{ type: 'required', message: 'Required' }],
    preheader: [],
    emailHtml: [{ type: 'required', message: 'Required' }],
    emailText: [],
    mobileText: [],
    headers: [],
    status: [],
    statusMsg: [],
    confId: [],
    trackingId: [],
    opsNotes: [],
    campaignVars: [],
		// msgCampaignAPI: [],
		msgRecipientAPIList: [],
  };
  msgTemplates: any;
  msgTemplateId: any;

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();
    // if we were passed the whole msg object
    if (this.msg) {
      this.msgId = this.msg.msgId;
      this.fixDates();
      this.form1.patchValue(this.msg);
    }
    this.form1.patchValue({
      senderName: (this.currentUser.lastName != undefined ? (this.currentUser.lastName + ' ') : '') + (this.currentUser.firstName != undefined ? (this.currentUser.firstName) : ''),
      senderEmail: this.currentUser.username
    });
    this.setupEMailIds();
    this.fetchAllTemplates();
    this.addUser();
  }

  updateEmailRecipients(selectedRecipients) {
    this.selectedMsgRecipients = selectedRecipients;
    console.log('Selected recipients in msg component:');
    console.log(this.selectedMsgRecipients);
  }


  addAndSendMail() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      const emailRecipients: MsgRecipient[] = [];
      if(this.showSendToNewUser && this.users.length > 0 && this.proforma != undefined) {
        this.form1.value.sendToNewUser = this.showSendToNewUser;
        this.form1.value.users = this.users.value;
        this.form1.value.proformaAPI = this.proforma;
        for (let mail of this.users.value) {
          mail = mail.emailAddress.trim();
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail;
          msgRecipient.emailRecipientType = 'To';
          emailRecipients.push(msgRecipient);
        }
      }
      else if (this.form1.value.toEmail && this.form1.value.toEmail.length > 0 ){
        for (let mail of this.form1.value.toEmail) {
          mail = mail.trim();
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail;
          msgRecipient.emailRecipientType = 'To';
          emailRecipients.push(msgRecipient);
        }
      }
      if (this.form1.value.ccEmail && this.form1.value.ccEmail.length > 0 ){
        for (const mail of this.form1.value.ccEmail) {
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail.trim();
          msgRecipient.emailRecipientType = 'Cc';
          emailRecipients.push(msgRecipient);
        }
      }
      if (this.form1.value.bccEmail && this.form1.value.bccEmail.length > 0 ){
        for (const mail of this.form1.value.bccEmail) {
          const msgRecipient = new MsgRecipient();
          msgRecipient.email = mail.trim();
          msgRecipient.emailRecipientType = 'Bcc';
          emailRecipients.push(msgRecipient);
        }
      }
      let mailSet = new Set();
      for (const receipient of emailRecipients){
        let mail = receipient.email;
        if (mailSet.has(mail)){
          this.alertService.error('To , Cc and Bcc should have unique mail Ids.');
            return;
        }
        else{
          mailSet.add(mail);
        }
      }
      this.form1.value.msgRecipientAPIList = emailRecipients;
      this.form1.value.emailText = this.form1.value.emailHtml;
      this.form1.value.topic = this.msg.topic;
      this.form1.value.topicId = this.msg.topicId;
      this.form1.value.toTagJoinAPIList = this.toTagsSelected;
      this.form1.value.ccTagJoinAPIList = this.ccTagsSelected;
      this.form1.value.bccTagJoinAPIList = this.bccTagsSelected;
      console.log("property-add post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgService.addAndSendMail(this.form1.value).subscribe(
        (res: any) => {
          console.log("property-add SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msg = res.data.msg;
          if (this.msg.confId != null && this.msg.confId.startsWith('20')) {
            this.doAdd.emit(this.msg);
          }
          else{
            let alertMsg = '';
            if ( this.msg.statusMsg ){
              try{
              let statusMsg = JSON.parse(this.msg.statusMsg);
                if (statusMsg.errors && statusMsg.errors.length > 0){
                  statusMsg.errors.forEach(function(obj) { alertMsg += obj.message + '<br>'; });
                  this.alertService.error('Faied to send mail: ' + alertMsg);
                }
              } catch (error) {
                this.alertService.error(error);
              }
            }
            else {
              this.alertService.error('Faied to send mail: ' + this.msg.statusMsg);
            }

          }
        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }



  sendMail() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      if(!this.msgId){
        this.addAndSendMail();
        return;
      }
      const emailRecipients: MsgRecipient[] = [];
      this.selectedMsgRecipients.forEach(msgRecipientId => {
        const msgRecipient = new MsgRecipient();
        msgRecipient.msgRecipientId = msgRecipientId;
        emailRecipients.push(msgRecipient);
      });
      this.form1.value.msgRecipientAPIList = emailRecipients;
      console.log("send message, post: " + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.msgService.send(this.form1.value).subscribe(
        (res: any) => {
          console.log("send message, SUCCESS: " + JSON.stringify(res));
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: res.message,
          });
          this.msg = res.data.msg;
          if (this.msg.confId != null && this.msg.confId.startsWith('20')) {
            this.doAdd.emit(this.msg);
          }
          else{
            this.alertService.error('Faied to send mail: ' + this.msg.statusMsg);
          }

        },
        (err: any) => {
          console.log("msg-add FAIL: " + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        }
      );
    } catch (error) {
      this.alertService.error(error);
    }
  }

  get users(): FormArray {
		return this.form1.get('users') as FormArray
	}

  // this method used to add new user
	addUser() {
		this.users.push(this.newUser());
	}

  // this method used to add new user
	removeUser(i) {
		this.users.removeAt(i);
	}

  newUser(): FormGroup {
		// if not testmode at that time set this build form
		return this._formBuilder.group({
			firstName: [''],
			lastName: [''],
			emailAddress: [''],
			mobilePhone: ['']
		})
	}

  formBuild() {
    this.form1 = this.formBuilder.group({
      msgId: [this.msgId],
      sentDate: [],
      receivedDate: [],
      senderName: ['', Validators.required],
      subject: ['', Validators.required],
      senderEmail: ['', Validators.required],
      toEmail: [],
      ccEmail: [],
      bccEmail: [],
      preheader: [],
      emailHtml: ['', Validators.required],
      emailText: [],
      headers: [],
      status: [],
      statusMsg: [],
      confId: [],
      trackingId: [],
      msgRecipientAPIList: [],
      users: new FormArray([])
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.msg.createDate = moment(this.msg.createDate).toDate();
    this.msg.lastUpdate = moment(this.msg.lastUpdate).toDate();
    this.msg.sentDate = moment(this.msg.sentDate).toDate();
    this.msg.receivedDate = moment(this.msg.receivedDate).toDate();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === ',' || event.key === ';' || event.key === ' ') {
      event.preventDefault();
      const element = event.target as HTMLElement;
      element.blur();
      element.focus();
    }
  }
  fetchAllTemplates() {
    if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
      try {
        this.msgTemplateService.findAllWithoutPage()
            .subscribe(
                res => {
                  console.log('employee Profiles: ' + JSON.stringify(res));
                  this.msgTemplates = res.data.msgTemplates;
                  if (this.msgTemplateId) {
                    const templateObj = this.msgTemplates.find(t => t.msgTemplateId === this.msgTemplateId);
                    if (templateObj) {
                      this.form1.patchValue({
                        msgTemplateId: templateObj,   // must pass whole object
                        emailHtml: templateObj.emailHtml,
                        subject: templateObj.subject,
                      });
                    }
                  }
                  return this.msgTemplates;
                },
                err => {
                  console.log('Feature-Update FAIL: ' + JSON.stringify(err));
                  this.alertService.error(err);
                },
                () => { });
      } catch (error) {
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
    else {
      return (this.msgTemplates);
    }
  }

  validateEmailAddress(event: any, elementData: any) {
    let eventdata = event.value.trim();
    let emails = [];
    let seperator ;
    if (eventdata.indexOf(' ') > 0 ){
      seperator = ' ';
      emails = eventdata.split(' ');
      elementData.pop();
    }
    else if (eventdata.indexOf(',') > 0 ){
      seperator = ',';
      emails = eventdata.split(',');
      elementData.pop();
    }
    else if (eventdata.indexOf(';') > 0 ){
      seperator = ';';
      emails = eventdata.split(';');
      elementData.pop();
    }
    if (emails.length === 0 && !this.validEMail(eventdata)){
      elementData.pop();
      return;
    }

    emails.forEach( mail => {
      if (this.validEMail(mail)) {
        elementData.push(mail);
      }
      else{
        this.form1.value.toEmail.pop();
      }
    });
  }
  validEMail(email: string){
    let regEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regEx.test(email);
  }

  private setupEMailIds() {
    let toEmailArray = [];
    let ccEmailArray = [];
    let bccEmailArray = [];
    if (this.toEmails ){
      let toEmails = this.toEmails.trim().split(',');
      toEmails.forEach(mail => {
        toEmailArray.push(mail.trim());
      });
    }
    if (this.ccEmails ){
      let ccEmails = this.ccEmails.trim().split(',');
        ccEmails.forEach(mail => {
        ccEmailArray.push(mail.trim());
      });
    }
    if (this.bccEmails ){
      let bccEmails = this.bccEmails.trim().split(',');
        bccEmails.forEach(mail => {
        bccEmailArray.push(mail.trim());
      });
    }
    this.form1.patchValue({
      toEmail: toEmailArray,
      ccEmail: ccEmailArray,
      bccEmail: bccEmailArray
    });
  }
  selectTemplate(event)
  {
      const selectedId = event?.value?.msgTemplateId;
      // nothing selected/cleared
      if (selectedId === null || selectedId === undefined || selectedId === '') {
        this.msgTemplateId = null;
        this.form1.patchValue({ msgTemplateId: null });
        return;
      }
        this.msgTemplateId = selectedId;
      // this.isTemplateLoading = true;
      if (this.form1.value.topic && this.form1.value.topicId) {

      this.formLoading = true;
      this.msgTemplateService.mergeTemplateBytopic(selectedId, this.form1.value.topic, this.form1.value.topicId).subscribe(
        (res: any) => {
          let msgTemplateLocal = res.data.msg;
           this.form1.patchValue({
              senderName: msgTemplateLocal?.senderName || null,
              senderEmail: msgTemplateLocal?.senderEmail || null
          });

          let mailText = msgTemplateLocal.emailHtml;
          let subject = msgTemplateLocal.subject;
          let smsText = msgTemplateLocal.mobileText;
          this.form1.patchValue({
            emailHtml: mailText,
            mobileText: smsText,
            subject: subject,
          });
          if( msgTemplateLocal?.opsNotes){
            this.alertService.error(msgTemplateLocal.opsNotes);
          }
        },
        (err: any) => {
          console.log('msgTemplate-add FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
          this.formLoading = false;
          // this.isTemplateLoading = false; 
        },
        () => {
          this.formLoading = false;
          // this.isTemplateLoading = false; 
        }
      );
    }
    else
    {
      try {
        // this.isTemplateLoading = true; 
        this.msgTemplateService.findById(selectedId)
        .subscribe(
        res => {
          const tpl = res.data?.msgTemplate;
          this.form1.patchValue({
              senderName: tpl?.senderName || null,
              senderEmail: tpl?.senderEmail || null
          });
          this.form1.patchValue({
            subject: tpl.subject,
            emailHtml: tpl.emailHtml,
            emailText: tpl.emailText,
            msgTemplateId: selectedId
          });
        },
        err => {
          this.alertService.error(err);
          // this.isTemplateLoading = false;
        },
        () => { 
          // this.isTemplateLoading = false;
        });
      } catch (error) {
        // this.isTemplateLoading = false;
        console.log('Form Invalid: ' + JSON.stringify(error));
        this.alertService.error(error);
      }
    }
  }

  toTagAdded($event: any) {
    this.toTagsSelected = $event;
  }

  ccTagAdded($event: any) {
    this.ccTagsSelected = $event;
  }

  bccTagAdded($event: any) {
    this.bccTagsSelected = $event;
  }
}
